import { render, staticRenderFns } from "./safetyPermitMaintenance.vue?vue&type=template&id=f60e6868&scoped=true"
import script from "./safetyPermitMaintenance.vue?vue&type=script&lang=js"
export * from "./safetyPermitMaintenance.vue?vue&type=script&lang=js"
import style0 from "./safetyPermitMaintenance.vue?vue&type=style&index=0&id=f60e6868&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60e6868",
  null
  
)

export default component.exports